import moment from 'moment'
import React from 'react'

// Style
import { NewsroomPostContainer, NewsroomTeaserContainer } from './style'

// Components
import Container from '@material-ui/core/Container'
import SEOTags from '../../../../global/seoTags'
import Layout from '../../../../layouts/layout'

import { renderRichText } from '../../../../../utils/richTextHandler.utils'

import ContentBlock from '../../../../global/contentBlock'
import Hero from '../../../../global/hero'
import Tiles from '../../../../global/tiles'
import ListingItem from '../listingItem'

// Constants
import { ModuleNames } from '../../../../../constants/componentNames.constants'

// Helpers
import { OPTIONS } from '../../../../../constants/dateOptions'
import { findTarget } from '../../../../../utils/microcopy.utils'

const NewsroomPost = ({
  path,
  pageContext,
  location,
  headerData,
  footerData,
  announcementData,
  mainNavBannerData,
  browserLanguageData,
}: any) => {
  if (pageContext.postData) {
    const seoData = pageContext.postData.seoMetadata ? pageContext.postData.seoMetadata : null
    const locale = pageContext.postData.node_locale ? pageContext.postData.node_locale : null

    const twoTeasers = Array.isArray(pageContext.twoTeasers) ? pageContext.twoTeasers : []

    let teaserMarkup = twoTeasers.map((teaser: any, index: number) => {
      let listingTitle = teaser.title || '',
        listingDate = teaser.date || '',
        listingSlug = teaser.slug || '',
        listingUrl = teaser.url1 || '',
        listingType = teaser.articleType || teaser.category?.title,
        listingPublication =
          teaser.metaInformation && teaser.metaInformation[0]
            ? teaser.metaInformation[0].customerName
            : ''
      const date = new Date(listingDate)
      let formattedDate = date && moment(date).utc().format('D MMMM YYYY')
      formattedDate = new Date(formattedDate).toLocaleDateString(locale, OPTIONS)

      return (
        <ListingItem
          key={`ListItem--${listingSlug}-${index}`}
          {...{
            listingTitle,
            listingSlug,
            listingUrl,
            listingType,
            listingPublication,
            formattedDate,
          }}
        />
      )
    })

    const slug = pageContext.postData.slug
    const body = pageContext.postData.body ? pageContext.postData.body : null
    const headline = pageContext.postData.title || ''
    const date = pageContext.postData.date

    let formattedDate: any
    if (date) {
      formattedDate = new Date(date)
      formattedDate = moment(formattedDate).utc().format('MMMM D, YYYY')
      formattedDate = new Date(formattedDate).toLocaleDateString(locale, OPTIONS)
    }

    const subheadline = formattedDate || ''

    const microcopySet = pageContext.postData.microcopy ? pageContext.postData.microcopy : null

    let eyebrow = ''
    if (microcopySet) {
      eyebrow =
        microcopySet.values && Array.isArray(microcopySet.values)
          ? findTarget('newsroom.article.Eyebrow.text', microcopySet.values)
          : eyebrow
    }

    const pageTitle = pageContext.postData.pageName

    const heroProps = {
      headline: headline,
      subheadline: {
        subheadline: subheadline,
      },
      eyebrow: eyebrow,
      heroTheme: 'light',
      backgroundAsset: {
        image: {
          file: {
            url: '//images.ctfassets.net/5965pury2lcm/2INaGHDDw9uI0HAkIzpHLU/b8fab74cb56f36e75608f760b0d7f2e2/Hero_Newsroom_2x.png',
          },
        },
      },
    }
    const hero = (
      <Hero
        data={heroProps}
        location={location}
        pageTitle={pageTitle}
        showBreadcrumbs={true}
        pageType="flex"
        locale={locale}
        breadcrumb={pageContext.postData.breadcrumb}
      />
    )

    let pressReleaseBoilerPlate = []
    if (pageContext.pressReleaseBoilerPlate?.contentEntries?.length) {
      const entries = pageContext.pressReleaseBoilerPlate.contentEntries
      for (let i = 0; i < entries.length; i++) {
        if (entries[i].__typename === ModuleNames.GLOBAL_CONTENT_BLOCK) {
          pressReleaseBoilerPlate.push(
            <ContentBlock key={`pressReleaseBoilerPlate-${i}`} data={entries[i]} />
          )
        } else if (entries[i].__typename === ModuleNames.TILES) {
          pressReleaseBoilerPlate.push(
            <Tiles key={`pressReleaseBoilerPlate-${i}`} data={entries[i]} />
          )
        }
      }
    }

    let socialMediaBoilerPlate = []
    if (pageContext.socialMediaBoilerPlate?.contentEntries?.length) {
      const entries = pageContext.socialMediaBoilerPlate.contentEntries
      for (let i = 0; i < entries.length; i++) {
        if (entries[i].__typename === ModuleNames.GLOBAL_CONTENT_BLOCK) {
          socialMediaBoilerPlate.push(
            <ContentBlock key={`socialMediaBoilerPlate-${i}`} data={entries[i]} />
          )
        } else if (entries[i].__typename === ModuleNames.TILES) {
          socialMediaBoilerPlate.push(
            <Tiles key={`socialMediaBoilerPlate-${i}`} data={entries[i]} />
          )
        }
      }
    }

    return (
      <Layout.Template
        lang={locale}
        pageType="newsroomPost"
        slug={slug}
        headerData={headerData}
        footerData={footerData}
        announcementData={announcementData}
        mainNavBannerData={mainNavBannerData}
        browserLanguageData={browserLanguageData}
        availableLocales={pageContext.availableLocales}>
        <div data-cy="NewsroomPost">
          <SEOTags
            seoMetadata={seoData}
            path={path}
            slug={slug}
            locale={locale}
            availableLocales={pageContext.availableLocales}
          />
          <NewsroomPostContainer>
            {hero}
            <Container>
              <div className="NewsroomPost__Post-Container">
                {/* Social Media */}
                <div className="NewsroomPost__SocialMedia-Container">
                  <a
                    className="NewsroomPost__SocialMedia-Item"
                    target="_blank"
                    href={`https://twitter.com/intent/tweet?original_referer=https%3A%2F%2Fwww.uipath.com%2F&ref_src=twsrc%5Etfw&text=${headline
                      .split(' ')
                      .join('+')}&tw_p=tweetbutton&url=https://www.uipath.com/${slug}`}>
                    <svg
                      xmlns="https://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24">
                      <path
                        d="M19.348,1.866a8.309,8.309,0,0,1-1.989,2.05q.012.172.012.516a11.265,11.265,0,0,1-.467,3.186,11.513,11.513,0,0,1-1.418,3.051,11.993,11.993,0,0,1-2.265,2.584,10.085,10.085,0,0,1-3.167,1.792,11.592,11.592,0,0,1-3.965.669A11.012,11.012,0,0,1,0,13.934a8.487,8.487,0,0,0,.958.049,7.764,7.764,0,0,0,4.923-1.694,3.974,3.974,0,0,1-3.708-2.75,5.024,5.024,0,0,0,.749.061,4.1,4.1,0,0,0,1.044-.135A3.9,3.9,0,0,1,1.688,8.1a3.831,3.831,0,0,1-.9-2.523V5.525a3.934,3.934,0,0,0,1.792.5A3.961,3.961,0,0,1,1.289,4.616,3.864,3.864,0,0,1,.81,2.725a3.885,3.885,0,0,1,.54-2A11.241,11.241,0,0,0,4.966,3.652,11.049,11.049,0,0,0,9.527,4.874a4.4,4.4,0,0,1-.1-.908,3.822,3.822,0,0,1,1.16-2.805,3.975,3.975,0,0,1,5.7.092A7.775,7.775,0,0,0,18.808.295,3.85,3.85,0,0,1,17.065,2.48,7.9,7.9,0,0,0,19.348,1.866Z"
                        transform="translate(2.326 4.286)"></path>
                    </svg>
                  </a>
                  <a
                    className="NewsroomPost__SocialMedia-Item"
                    target="_blank"
                    href={`https://www.linkedin.com/shareArticle?mini=true&url=https://www.uipath.com/${slug}&title=text=${headline
                      .split(' ')
                      .join('%20')}&summary=${headline
                      .split(' ')
                      .join('%20')}&source=https%3A%2F%2Fwww.uipath.com`}>
                    <svg
                      xmlns="https://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24">
                      <path
                        d="M10.558,18.024H6.519c.017-3.356.025-5.954.025-7.943s0-3.234-.013-3.634l-.013-.589h4.039V7.585a5.3,5.3,0,0,1,.479-.649,5.226,5.226,0,0,1,.694-.638A3.2,3.2,0,0,1,12.8,5.764a4.883,4.883,0,0,1,1.4-.19,4.381,4.381,0,0,1,3.377,1.393,5.871,5.871,0,0,1,1.276,4.082v6.972H14.818V11.516a3.569,3.569,0,0,0-.5-2.02,1.752,1.752,0,0,0-1.552-.73,2,2,0,0,0-1.3.423,2.631,2.631,0,0,0-.779,1.049,2.985,2.985,0,0,0-.135.995v6.79Zm-6.273,0H.233V5.856H4.285V18.022ZM2.259,4.2H2.235A2.228,2.228,0,0,1,.614,3.6,2.021,2.021,0,0,1,0,2.1,1.984,1.984,0,0,1,.633.6,2.319,2.319,0,0,1,2.283,0,2.253,2.253,0,0,1,3.916.6a2.055,2.055,0,0,1,.626,1.5,1.951,1.951,0,0,1-.62,1.5A2.324,2.324,0,0,1,2.259,4.2Z"
                        transform="translate(2.571 2.96)"></path>
                    </svg>
                  </a>
                  <a
                    className="NewsroomPost__SocialMedia-Item"
                    target="_blank"
                    href={`https://www.facebook.com/sharer/sharer.php?u=https://www.uipath.com/${slug}&display=popup&ref=plugin&src=like&kid_directed_site=0`}>
                    <svg
                      xmlns="https://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24">
                      <path
                        d="M10.607.147V3.388H8.68a1.8,1.8,0,0,0-1.424.442,2.034,2.034,0,0,0-.368,1.326v2.32h3.6l-.479,3.634H6.887v9.318H3.131V11.11H0V7.477H3.131V4.8A4.749,4.749,0,0,1,4.407,1.258,4.634,4.634,0,0,1,7.808,0,20.309,20.309,0,0,1,10.607.147Z"
                        transform="translate(6.881 1.143)"></path>
                    </svg>
                  </a>
                </div>
                {/* Post Body */}
                <div className="NewsroomPost__Body-Container">
                  <div className="NewsroomPost__Body">{body && renderRichText(body)}</div>
                  {pressReleaseBoilerPlate}
                </div>
              </div>
            </Container>
            {teaserMarkup && <NewsroomTeaserContainer>{teaserMarkup}</NewsroomTeaserContainer>}
            {socialMediaBoilerPlate}
          </NewsroomPostContainer>
        </div>
      </Layout.Template>
    )
  }
  return null
}

export default NewsroomPost
